import image1 from "../../assets/content1.jpg";
import image2 from "../../assets/content2.jpg";
import image3 from "../../assets/content3.jpg";
import image4 from "../../assets/content4.jpg";
import image5 from "../../assets/content5.jpg";
import image6 from "../../assets/content6.jpg";
import image7 from "../../assets/content7.jpg";
import image8 from "../../assets/content8.jpg";
import image9 from "../../assets/client1.png";
import image10 from "../../assets/client2.png";
import image11 from "../../assets/client3.png";
import image12 from "../../assets/client4.png";
import image13 from "../../assets/client5.png";
import image14 from "../../assets/client6.png";
import image15 from "../../assets/client7.png";

export const BRAND = [
  {
    id: 1,
    image: image1,
  },
  {
    id: 2,
    image: image2,
  },
  {
    id: 3,
    image: image3,
  },
  {
    id: 4,
    image: image4,
  },
  {
    id: 5,
    image: image5,
  },
  {
    id: 6,
    image: image6,
  },
  {
    id: 7,
    image: image7,
  },
  {
    id: 8,
    image: image8,
  },
];

export const SLIDEIMAGE = [
  {
    id: 9,
    slideImage: image9,
  },
  {
    id: 10,
    slideImage: image10,
  },
  {
    id: 11,
    slideImage: image11,
  },
  {
    id: 12,
    slideImage: image12,
  },
  {
    id: 13,
    slideImage: image13,
  },
  {
    id: 14,
    slideImage: image14,
  },
  {
    id: 15,
    slideImage: image15,
  },
];
